import { TemplateResult, html, CSSResultGroup } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';

import componentStyles from './ghs-form.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { LegacySlotController } from '../../controllers/legacy-slot-controller';

export type FormActionsAlignment = 'left' | 'center' | 'right';
export type FormVariant = 'default' | 'lightest-bg';
/**
 * The GhsForm component
 * @element ghs-bottom
 */
@customElement('ghs-form')
export class GhsForm extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  // This uses the legacy slot controller because the newer slot controller breaks the facet select filters on views.
  legacySlotController = new LegacySlotController(this);

  @property({ type: String, reflect: true, attribute: 'variant' })
  variant: FormVariant = 'default';

  @property({ type: Boolean, reflect: true, attribute: 'content-half-padding' })
  contentHalfPadding = false;

  @property({ type: Boolean, reflect: true, attribute: 'content-no-padding' })
  contentNoPadding = false;

  @property({ type: Boolean, reflect: true, attribute: 'full-bleed' })
  fullBleed = false;

  /**
   * Create a grid with n equally sized columns.
   */
  @property({ type: Number })
  cols: number;

  /**
   * Actions elements alignment style.
   * @param actionsAlignment
   */
  @property({ type: String, reflect: true, attribute: 'actions-alignment' })
  actionsAlignment: FormActionsAlignment;

  render(): TemplateResult {
    const classes = {
      'ghs-form': true,
      [`ghs-form--columns-${this.cols}`]: this.cols,
      [`ghs-form--actions-${this.actionsAlignment}`]: this.actionsAlignment,
      [`ghs-form--variant-${this.variant}`]: this.variant,
      [`ghs-form--content-half-padding`]: this.contentHalfPadding,
      [`ghs-form--content-no-padding`]: this.contentNoPadding,
      [`ghs-form--full-bleed`]: this.fullBleed,
    };

    return html`<div class=${classMap(classes)}>
      <div class="form-content-wrapper"><slot></slot></div>
    </div>`;
  }
}
